import React from 'react';

import {
  SvgIconProps,
  useTheme
} from '@mui/material';

import { ReactComponent as Close } from '../../../../assets/icons/medium/close.svg';
import { ReactComponent as Bag } from '../../../../assets/icons/medium/bag.svg';
import { ReactComponent as Chevrondown } from '../../../../assets/icons/medium/chevronDown.svg';
import { ReactComponent as Chevronleft } from '../../../../assets/icons/medium/chevronLeft.svg';
import { ReactComponent as Chevronright } from '../../../../assets/icons/medium/chevronRight.svg';
import { ReactComponent as Chevronup } from '../../../../assets/icons/medium/chevronUp.svg';
import { ReactComponent as Doorhandle } from '../../../../assets/icons/medium/doorHandle.svg';
import { ReactComponent as Flag1 } from '../../../../assets/icons/medium/flag1.svg';
import { ReactComponent as Flagalt } from '../../../../assets/icons/medium/flagAlt.svg';
import { ReactComponent as Lock } from '../../../../assets/icons/medium/lock.svg';

export type CustomIconProps = {
  icon: IconTypes;
};

export type IconTypes =
  'BAG' |
  'LOCK' |
  'FLAGALT' |
  'FLAG1' |
  'DOORHANDLE' |
  'CLOSE' |
  'CHEVRONUP' |
  'CHEVRONRIGHT' |
  'CHEVRONLEFT' |
  'CHEVRONDOWN';


export const __icon2iconUrl: Record<IconTypes, React.ReactElement> = {
  BAG: <Bag />,
  CHEVRONDOWN: <Chevrondown />,
  CHEVRONLEFT: <Chevronleft />,
  CHEVRONRIGHT: <Chevronright />,
  CHEVRONUP: <Chevronup />,
  CLOSE: <Close />,
  DOORHANDLE: <Doorhandle />,
  FLAG1: <Flag1 />,
  FLAGALT: <Flagalt />,
  LOCK: <Lock />
};

export const FC = (props: CustomIconProps & SvgIconProps) => {
  const theme = useTheme();

  const Res = __icon2iconUrl[props.icon];
  const stroke = props.stroke
    ? props.stroke
    : theme.palette.customGray.dark;

  return (

    <Res.type
      {...props}
      stroke={stroke}
    />
  );
};
